import React from "react";
import "./growthChartTiles.scss";
import chart_icon from "../../../../../assets/chart_icon.svg";
import chart_icon_white from "../../../../../assets/chart_icon_white.svg";

const GrowthChartTiles = (props) => {
  const { title, subtitle, selected, handleTileSelection } = props;

  // Display UI ===>

  const displayGrowthChartTiles = () => {
    return (
      <div
        className={
          "growth-chart-tiles-cont " +
          (selected ? "growth-chart-tiles-cont-selected" : "")
        }
        onClick={handleTileSelection}
      >
        <div className="growth-chart-tiles-titles">
          <div
            className={
              "growth-chart-tiles-title " +
              (selected ? "growth-chart-tiles-selected" : "")
            }
          >
            {title}
          </div>
          {subtitle && (
            <div
              className={
                "growth-chart-tiles-subtitle " +
                (selected ? "growth-chart-tiles-selected" : "")
              }
            >
              {subtitle}
            </div>
          )}
        </div>
        <div
          className={
            "growth-chart-tiles-titles-img " +
            (selected ? "growth-chart-tiles-titles-img-selected" : "")
          }
        >
          <img src={selected ? chart_icon_white : chart_icon} alt="" />
        </div>
      </div>
    );
  };

  // <===

  return <div className="growth-chart-tiles">{displayGrowthChartTiles()}</div>;
};

export default GrowthChartTiles;
